import { FIXED_INDENTS, INDENTS, MULTI_COLUMN_GAP } from 'vars/index'

export const MultiColumnsDirection = {
  Row: 'row',
  Column: 'column',
} as const
export type MultiColumnsDirection =
  (typeof MultiColumnsDirection)[keyof typeof MultiColumnsDirection]

export const MultiColumnsJustifyContent = {
  FlexStart: 'flex-start',
  Center: 'center',
  FlexEnd: 'flex-end',
  SpaceBetween: 'space-between',
  SpaceAround: 'space-around',
  SpaceEvenly: 'space-evenly',
} as const
export type MultiColumnsJustifyContent =
  (typeof MultiColumnsJustifyContent)[keyof typeof MultiColumnsJustifyContent]

export const MultiColumnsAlignItems = {
  FlexStart: 'flex-start',
  Center: 'center',
  FlexEnd: 'flex-end',
  Baseline: 'baseline',
} as const
export type MultiColumnsAlignItems =
  (typeof MultiColumnsAlignItems)[keyof typeof MultiColumnsAlignItems]

export const MultiColumnsGap = {
  INDENT_0: INDENTS.INDENT_0,
  INDENT_20: INDENTS.INDENT_20,
  INDENT_40: INDENTS.INDENT_40,
  INDENT_60: INDENTS.INDENT_60,
  INDENT_80: INDENTS.INDENT_80,
  ADAPTIVE_SIZE_10: MULTI_COLUMN_GAP.SIZE_10,
} as const
export type MultiColumnsGap =
  (typeof MultiColumnsGap)[keyof typeof MultiColumnsGap]

export const MultiColumnsRowGap = {
  INDENT_0: INDENTS.INDENT_0,
  INDENT_10: INDENTS.INDENT_10,
  INDENT_20: INDENTS.INDENT_20,
  INDENT_40: INDENTS.INDENT_40,
  INDENT_60: INDENTS.INDENT_60,
  INDENT_80: INDENTS.INDENT_80,
} as const
export type MultiColumnsRowGap =
  (typeof MultiColumnsRowGap)[keyof typeof MultiColumnsRowGap]

type PaddingKey = 'SIZE_10'
export const MultiColumnsPaddings: Record<
  PaddingKey,
  readonly [string, string, string, string]
> = {
  SIZE_10: [
    FIXED_INDENTS.INDENT_70,
    FIXED_INDENTS.INDENT_140,
    FIXED_INDENTS.INDENT_80,
    FIXED_INDENTS.INDENT_140,
  ],
} as const
export type MultiColumnsPadding =
  (typeof MultiColumnsPaddings)[keyof typeof MultiColumnsPaddings]
